(function() {
    'use strict';

    angular
        .module('app')
        .directive('keyboardSupport', keyboardSupport);

    keyboardSupport.$inject = ['$window'];
    
    function keyboardSupport ($window) {
        // Usage:
        //     <keyboardSupport></keyboardSupport>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                showDropdown: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {

            scope.$watch(function () {
                return scope.showDropdown;
            }, function (value) {
                if (value) {
                    $timeout(function () {
                        $('#searchfield').get(0).focus();
                    })
                    $(document).unbind("keydown");
                    $(document).bind("keydown", keyDown);
                    scope.currentSelected = 0;
                    scope.onSelectionChanged(scope.currentSelected);
                    $(element).scrollTop(0);
                    scope.$apply;

                }
                else {
                    $(element).scrollTop(0);
                    $('#simplecriteria').get(0).focus();
                    $(document).unbind("keydown");
                }
            })



        }
    }

})();